import { PdfFileService } from './../../services/pdf-file.service';
import { DatePipe } from '@angular/common';
import { ExcelFileService } from './../../services/excel-file.service';
import { FileExportService } from './../../services/file-export.service';
import { ReportDateRangeDto } from './../../model/report-date-range-dto';
import { HttpclientService } from './../../services/httpclient.service';
import { MonthlyLocationDto } from './../../model/monthly-location-dto';
import { AppSettingService } from './../../services/app-setting.service';
import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import { PoOrderByPipe } from 'src/app/pipes/po-order-by.pipe';

@Component({
  selector: 'app-monthly-location-report',
  templateUrl: './monthly-location-report.component.html',
  styleUrls: ['./monthly-location-report.component.css']
})
export class MonthlyLocationReportComponent implements OnInit {
  maxMonthlyLocationDate: moment.Moment;
  monthlyLocationDateRange;
  monthlyLocationDateRangeStart;
  monthlyLocationDateRangeEnd;
  mlrExportModal: string;
  mlrSelectAllRowModal: boolean;
  public mlrloading: boolean;
  public mlrPaginationConfiguration;
  mlrPaginationcount = 25;
  monthlyLocationDtoList: MonthlyLocationDto[];
  monthlyLocationDtoSelectedList: MonthlyLocationDto[];
  selectedmonthlyLocationDto: any = [];
  reportDateRangeDto: ReportDateRangeDto;
  numberofexecution = 0;
  clearMlrSelection: MonthlyLocationDto[];
  sortArry: MonthlyLocationDto[];

  isLocationNumberSortCollapsedUpArrow: boolean;
  isLocationNumberSortCollapsedDownArrow: boolean;
  isLocationNameSortCollapsedUpArrow: boolean;
  isLocationNameSortCollapsedDownArrow: boolean;
  isAddress1SortCollapsedUpArrow: boolean;
  isAddress1SortCollapsedDownArrow: boolean;
  isCustomerAddress2SortCollapsedUpArrow: boolean;
  isCustomerAddress2SortCollapsedDownArrow: boolean;
  isCitySortCollapsedUpArrow: boolean;
  isCitySortCollapsedDownArrow: boolean;
  isCreationDateSortCollapsedUpArrow: boolean;
  isCreationDateSortCollapsedDownArrow: boolean;

  constructor(public appSettingService: AppSettingService, private httpclientService: HttpclientService,
              public fileExportService: FileExportService, public excelFileService: ExcelFileService, public datePipe: DatePipe,
              public pdfFileService: PdfFileService, private pipe: PoOrderByPipe) { }

  ngOnInit() {
    this.monthlyLocationDtoList = [];
    this.mlrExportModal = this.appSettingService.exportList[0];
    this.maxMonthlyLocationDate = moment().add(0, 'days');
    this.mlrExportModal = this.appSettingService.exportList[0];
    this.mlrPaginationConfiguration = { currentPage: '25 per page', itemsPerPage: '25' };
    this.monthlyLocationDateRange = '';
    this.initialSortValue();
  }

/****************************************************** Clear Selction Start ***************************************************/


initialSortValue() {
  this.isLocationNumberSortCollapsedUpArrow = true;
  this.isLocationNumberSortCollapsedDownArrow = true;
  this.isLocationNameSortCollapsedUpArrow = true;
  this.isLocationNameSortCollapsedDownArrow = true;
  this.isAddress1SortCollapsedUpArrow = true;
  this.isAddress1SortCollapsedDownArrow = true;
  this.isCustomerAddress2SortCollapsedUpArrow = true;
  this.isCustomerAddress2SortCollapsedDownArrow = true;
  this.isCitySortCollapsedUpArrow  = true;
  this.isCitySortCollapsedDownArrow  = true;
  this.isCreationDateSortCollapsedUpArrow = true;
  this.isCreationDateSortCollapsedDownArrow = true;
}
  clearAllSelection() {
     this.mlrSelectAllRowModal = false;
     this.initialSortValue();
    // this.clearMlrSelection = [];
    // this.monthlyLocationDtoList.forEach(pdto => {
    //   pdto.rowCheck = false;
    //   this.clearMlrSelection.push(pdto);
    // });
    // this.monthlyLocationDtoList = this.clearMlrSelection;
  }
/****************************************************** Clear Selction End ***************************************************/

/****************************************************** Table Sort Start ***************************************************/
  ChangeMlrSortOrder(exportData) {
    this.mlrExportModal = exportData;
  }

  onChangeMlrSort(event: any, upDown: boolean, propertyName: string) {
    if (propertyName === 'customerLocationid' ) {
      this.isLocationNameSortCollapsedUpArrow = true;
      this.isLocationNameSortCollapsedDownArrow = true;
      this.isAddress1SortCollapsedUpArrow = true;
      this.isAddress1SortCollapsedDownArrow = true;
      this.isCustomerAddress2SortCollapsedUpArrow = true;
      this.isCustomerAddress2SortCollapsedDownArrow = true;
      this.isCitySortCollapsedUpArrow  = true;
      this.isCitySortCollapsedDownArrow  = true;
      this.isCreationDateSortCollapsedUpArrow = true;
      this.isCreationDateSortCollapsedDownArrow = true;
      if (upDown) {
    this.sortArry = [];
    this.sortArry = this.pipe.transform(this.monthlyLocationDtoList, propertyName, upDown);
    this.monthlyLocationDtoList = [];
    this.monthlyLocationDtoList = this.sortArry;
    this.isLocationNumberSortCollapsedUpArrow = !this.isLocationNumberSortCollapsedUpArrow;
    this.isLocationNumberSortCollapsedDownArrow = true;
} else {
  this.sortArry = [];
  this.sortArry = this.pipe.transform(this.monthlyLocationDtoList, propertyName, upDown);
  this.monthlyLocationDtoList = [];
  this.monthlyLocationDtoList = this.sortArry;
  this.isLocationNumberSortCollapsedDownArrow = !this.isLocationNumberSortCollapsedDownArrow;
  this.isLocationNumberSortCollapsedUpArrow = true;
}
  } else if (propertyName === 'customerLocationName' ) {
    this.isLocationNumberSortCollapsedUpArrow = true;
    this.isLocationNumberSortCollapsedDownArrow = true;
    this.isAddress1SortCollapsedUpArrow = true;
    this.isAddress1SortCollapsedDownArrow = true;
    this.isCustomerAddress2SortCollapsedUpArrow = true;
    this.isCustomerAddress2SortCollapsedDownArrow = true;
    this.isCitySortCollapsedUpArrow  = true;
    this.isCitySortCollapsedDownArrow  = true;
    this.isCreationDateSortCollapsedUpArrow = true;
    this.isCreationDateSortCollapsedDownArrow = true;
    if (upDown) {
    this.sortArry = [];
    this.sortArry = this.pipe.transform(this.monthlyLocationDtoList, propertyName, true);
    this.monthlyLocationDtoList = [];
    this.monthlyLocationDtoList = this.sortArry;
    this.isLocationNameSortCollapsedUpArrow = !this.isLocationNameSortCollapsedUpArrow;
    this.isLocationNameSortCollapsedDownArrow = true;
} else {
  this.sortArry = [];
  this.sortArry = this.pipe.transform(this.monthlyLocationDtoList, propertyName, false);
  this.monthlyLocationDtoList = [];
  this.monthlyLocationDtoList = this.sortArry;
  this.isLocationNameSortCollapsedDownArrow = !this.isLocationNameSortCollapsedDownArrow;
  this.isLocationNameSortCollapsedUpArrow = true;
}
  } else if (propertyName === 'customerAddress1' ) {
    this.isLocationNumberSortCollapsedUpArrow = true;
    this.isLocationNameSortCollapsedDownArrow = true;
    this.isLocationNameSortCollapsedUpArrow = true;
    this.isLocationNameSortCollapsedDownArrow = true;
    this.isCustomerAddress2SortCollapsedUpArrow = true;
    this.isCustomerAddress2SortCollapsedDownArrow = true;
    this.isCitySortCollapsedUpArrow  = true;
    this.isCitySortCollapsedDownArrow  = true;
    this.isCreationDateSortCollapsedUpArrow = true;
    this.isCreationDateSortCollapsedDownArrow = true;
    if (upDown) {
    this.sortArry = [];
    this.sortArry = this.pipe.transform(this.monthlyLocationDtoList, propertyName, true);
    this.monthlyLocationDtoList = [];
    this.monthlyLocationDtoList = this.sortArry;
    this.isAddress1SortCollapsedUpArrow = !this.isAddress1SortCollapsedUpArrow;
    this.isAddress1SortCollapsedDownArrow = true;
} else {
  this.sortArry = [];
  this.sortArry = this.pipe.transform(this.monthlyLocationDtoList, propertyName, false);
  this.monthlyLocationDtoList = [];
  this.monthlyLocationDtoList = this.sortArry;
  this.isAddress1SortCollapsedDownArrow = !this.isAddress1SortCollapsedDownArrow;
  this.isAddress1SortCollapsedUpArrow = true;
}
  } else if (propertyName === 'customerAddress2' ) {
    this.isLocationNumberSortCollapsedUpArrow = true;
    this.isLocationNameSortCollapsedDownArrow = true;
    this.isLocationNameSortCollapsedUpArrow = true;
    this.isLocationNameSortCollapsedDownArrow = true;
    this.isAddress1SortCollapsedUpArrow = true;
    this.isAddress1SortCollapsedDownArrow = true;
    this.isCitySortCollapsedUpArrow  = true;
    this.isCitySortCollapsedDownArrow  = true;
    this.isCreationDateSortCollapsedUpArrow = true;
    this.isCreationDateSortCollapsedDownArrow = true;
    if (upDown) {
    this.sortArry = [];
    this.sortArry = this.pipe.transform(this.monthlyLocationDtoList, propertyName, true);
    this.monthlyLocationDtoList = [];
    this.monthlyLocationDtoList = this.sortArry;
    this.isCustomerAddress2SortCollapsedUpArrow = !this.isCustomerAddress2SortCollapsedUpArrow;
    this.isCustomerAddress2SortCollapsedDownArrow = true;
} else {
  this.sortArry = [];
  this.sortArry = this.pipe.transform(this.monthlyLocationDtoList, propertyName, false);
  this.monthlyLocationDtoList = [];
  this.monthlyLocationDtoList = this.sortArry;
  this.isCustomerAddress2SortCollapsedDownArrow = !this.isCustomerAddress2SortCollapsedDownArrow;
  this.isCustomerAddress2SortCollapsedUpArrow = true;
}
  } else if (propertyName === 'customerCity' ) {
    this.isLocationNumberSortCollapsedUpArrow = true;
    this.isLocationNameSortCollapsedDownArrow = true;
    this.isLocationNameSortCollapsedUpArrow = true;
    this.isLocationNameSortCollapsedDownArrow = true;
    this.isAddress1SortCollapsedUpArrow = true;
    this.isAddress1SortCollapsedDownArrow = true;
    this.isCustomerAddress2SortCollapsedUpArrow = true;
    this.isCustomerAddress2SortCollapsedDownArrow = true;
    this.isCreationDateSortCollapsedUpArrow = true;
    this.isCreationDateSortCollapsedDownArrow = true;

    if (upDown) {
    this.sortArry = [];
    this.sortArry = this.pipe.transform(this.monthlyLocationDtoList, propertyName, true);
    this.monthlyLocationDtoList = [];
    this.monthlyLocationDtoList = this.sortArry;
    this.isCitySortCollapsedUpArrow = !this.isCitySortCollapsedUpArrow;
    this.isCitySortCollapsedDownArrow = true;
} else {
  this.sortArry = [];
  this.sortArry = this.pipe.transform(this.monthlyLocationDtoList, propertyName, false);
  this.monthlyLocationDtoList = [];
  this.monthlyLocationDtoList = this.sortArry;
  this.isCitySortCollapsedDownArrow = !this.isCitySortCollapsedDownArrow;
  this.isCitySortCollapsedUpArrow = true;
}
  } else if (propertyName === 'createdatetime' ) {
    this.isLocationNumberSortCollapsedUpArrow = true;
    this.isLocationNameSortCollapsedDownArrow = true;
    this.isLocationNameSortCollapsedUpArrow = true;
    this.isLocationNameSortCollapsedDownArrow = true;
    this.isAddress1SortCollapsedUpArrow = true;
    this.isAddress1SortCollapsedDownArrow = true;
    this.isCustomerAddress2SortCollapsedUpArrow = true;
    this.isCustomerAddress2SortCollapsedDownArrow = true;
    this.isCitySortCollapsedDownArrow = true;
    this.isCitySortCollapsedUpArrow = true;

    if (upDown) {
    this.sortArry = [];
    this.sortArry = this.pipe.transform(this.monthlyLocationDtoList, propertyName, true);
    this.monthlyLocationDtoList = [];
    this.monthlyLocationDtoList = this.sortArry;
    this.isCreationDateSortCollapsedUpArrow = !this.isCreationDateSortCollapsedUpArrow;
    this.isCreationDateSortCollapsedDownArrow = true;
} else {
  this.sortArry = [];
  this.sortArry = this.pipe.transform(this.monthlyLocationDtoList, propertyName, false);
  this.monthlyLocationDtoList = [];
  this.monthlyLocationDtoList = this.sortArry;
  this.isCreationDateSortCollapsedDownArrow = !this.isCreationDateSortCollapsedDownArrow;
  this.isCreationDateSortCollapsedUpArrow = true;
}
  }


  }

/****************************************************** Table Sort End ***************************************************/


/****************************************************** Row Selection Start ***************************************************/
  mlrOnSelectParticularRow(selectedItem: any, values: any) {
      if (values.currentTarget.checked) {
        this.fileExportService.selectedMonthLocationReportData.push(selectedItem);
      } else if (!values.currentTarget.checked) {
        this.fileExportService.selectedMonthLocationReportData =
        this.fileExportService.selectedMonthLocationReportData.filter(obj => obj !== selectedItem);
      }
      if (this.fileExportService.selectedMonthLocationReportData.length === this.monthlyLocationDtoList.length) {
        this.mlrSelectAllRowModal = true;
      } else {
        this.mlrSelectAllRowModal = false;
      }
  }

  mlrOnSelectAllRow(values: any) {
    this.monthlyLocationDtoSelectedList = [];
    if (values.currentTarget.checked) {
      this.monthlyLocationDtoList.forEach(pdto => {
        pdto.rowCheck = true;
        this.monthlyLocationDtoSelectedList.push(pdto);
      });
      this.monthlyLocationDtoList = this.monthlyLocationDtoSelectedList;
      this.fileExportService.selectedMonthLocationReportData = this.monthlyLocationDtoSelectedList;
    } else {
      this.monthlyLocationDtoList.forEach(pdto => {
        pdto.rowCheck = false;
        this.monthlyLocationDtoSelectedList.push(pdto);
      });
      this.monthlyLocationDtoList = this.monthlyLocationDtoSelectedList;
      this.fileExportService.selectedMonthLocationReportData = [];
    }
  }
/****************************************************** Row Selection End ***************************************************/

/****************************************************** Date Picker Block Start ***************************************************/
  monthlyLocationDateChange() {
    this.fileExportService.selectedMonthLocationReportData = [];
   // this.clearAllSelection();
    if (this.monthlyLocationDateRange.monthlyLocationDateRangeStart !== undefined &&
      this.monthlyLocationDateRange.monthlyLocationDateRangeStart !== null) {
      this.mlrloading = true;
      this.reportDateRangeDto = {
        start: this.monthlyLocationDateRange.monthlyLocationDateRangeStart.format('YYYY-MM-DD'),
        end: this.monthlyLocationDateRange.monthlyLocationDateRangeEnd.format('YYYY-MM-DD'),
      };
      this.httpclientService.getMonthlyLocationReportByDate(this.reportDateRangeDto).subscribe(
        data => {
          this.mlrloading = false;
          this.clearAllSelection();
          this.monthlyLocationDtoList = data;
        }
      );
    }
  }
/****************************************************** Date Picker Block End ***************************************************/

/****************************************************** File Export Start ***************************************************/
modalPopup : boolean=false;
modalPopupString: string;
pressingOK(){
  this.modalPopup=false;
}  

mlrExportFile() {
    if (this.monthlyLocationDtoList == null || this.monthlyLocationDtoList == undefined || this.monthlyLocationDtoList.length === 0) {
      this.modalPopupString="No Data to Export";
      this.modalPopup=true;
      return;
     } //else {

      let flag : boolean=false;
      
       if (this.fileExportService.selectedMonthLocationReportData.length === 0) {
         flag=true;
         this.selectedmonthlyLocationDto = [];
         this.monthlyLocationDtoList.forEach(pdto => {
           pdto.rowCheck = true;
           this.selectedmonthlyLocationDto.push(pdto);
         });
         this.monthlyLocationDtoList = this.selectedmonthlyLocationDto;
         this.fileExportService.selectedMonthLocationReportData = this.selectedmonthlyLocationDto;
       }


      if (this.mlrExportModal === 'PDF') {
        this.pdfFileService.exportMonthlyLocationReport('Monthly Location Report');
      } else if (this.mlrExportModal === 'Excel') {
        this.selectedmonthlyLocationDto = [];
        this.fileExportService.selectedMonthLocationReportData.forEach(pdto => {
          if (pdto.rowCheck) {
            let address2: any;
            let createDateTime: any;
            if (pdto.customerAddress2 === null) {
              address2 = '';
            } else {
              address2 = pdto.customerAddress2;
            }
            createDateTime = this.datePipe.transform(pdto.createdatetime, this.appSettingService.globelDateTimeFormat);
            this.selectedmonthlyLocationDto.push({
              'Location Number': `${pdto.customerLocationid}`, 'Customer Location Name': `${pdto.customerLocationName}`,
              'Customer Address1': `${pdto.customerAddress1}`, 'Customer Address2': `` + address2,
              City: `${pdto.customerCity}`, 'Creation Date in M2M': `` + createDateTime
            });
          }
        });
        this.excelFileService.exportMonthlyLocationReportExcel(this.selectedmonthlyLocationDto, 'Monthly Location Report');
      }
    // }
    if(flag){
      this.selectedmonthlyLocationDto = [];
      this.monthlyLocationDtoList.forEach(pdto => {
        pdto.rowCheck = false;
        this.selectedmonthlyLocationDto.push(pdto);
      });
      this.monthlyLocationDtoList = this.selectedmonthlyLocationDto;
      this.fileExportService.selectedMonthLocationReportData = [];
    }
  }
/****************************************************** File Export End ***************************************************/

/****************************************************** Pagination Start ***************************************************/
  mlrOnChangePagination(value) {

    this.mlrPaginationConfiguration.itemsPerPage = value;
    this.mlrPaginationcount = value;
  }

  mlrPageOnChanged(event) {
    this.mlrPaginationConfiguration.currentPage = event;
  }
/****************************************************** Pagination End ***************************************************/

}
